// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StoreView_store-view-container__9lFDo {
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  background: #f8f9fa;
  min-height: 100vh;
}
.StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 15px;
}
.StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq h2 {
  color: #2c3e50;
  font-size: 2rem;
  font-weight: 600;
  margin: 0;
}
.StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}
.StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 .StoreView_pagination-controls__HIzsP {
  display: flex;
  align-items: center;
  gap: 10px;
}
.StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 .StoreView_pagination-controls__HIzsP label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  color: #4a5568;
  font-weight: 500;
}
.StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 .StoreView_pagination-controls__HIzsP .StoreView_items-per-page__wDpBv {
  padding: 6px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: white;
  font-size: 0.9rem;
  color: #2d3748;
  cursor: pointer;
  transition: all 0.2s ease;
}
.StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 .StoreView_pagination-controls__HIzsP .StoreView_items-per-page__wDpBv:focus {
  outline: none;
  border-color: #3498db;
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);
}
.StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 .StoreView_pagination-controls__HIzsP .StoreView_items-per-page__wDpBv:hover {
  border-color: #cbd5e0;
}
.StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 .StoreView_refresh-btn__Zju0k,
.StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 .StoreView_print-btn__mx6fB,
.StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 .StoreView_filter-btn__RFeYq,
.StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 .StoreView_excel-btn__W9QQb {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}
.StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 .StoreView_refresh-btn__Zju0k:hover,
.StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 .StoreView_print-btn__mx6fB:hover,
.StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 .StoreView_filter-btn__RFeYq:hover,
.StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 .StoreView_excel-btn__W9QQb:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 .StoreView_refresh-btn__Zju0k {
  background: #3498db;
  color: white;
}
.StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 .StoreView_refresh-btn__Zju0k:hover {
  background: #2980b9;
  box-shadow: 0 4px 8px rgba(52, 152, 219, 0.3);
}
.StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 .StoreView_print-btn__mx6fB {
  background: #27ae60;
  color: white;
}
.StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 .StoreView_print-btn__mx6fB:hover {
  background: #229954;
  box-shadow: 0 4px 8px rgba(39, 174, 96, 0.3);
}
.StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 .StoreView_filter-btn__RFeYq {
  background: #9b59b6;
  color: white;
}
.StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 .StoreView_filter-btn__RFeYq:hover {
  background: #8e44ad;
  box-shadow: 0 4px 8px rgba(155, 89, 182, 0.3);
}
.StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 .StoreView_excel-btn__W9QQb {
  background: #f39c12;
  color: white;
}
.StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 .StoreView_excel-btn__W9QQb:hover {
  background: #e67e22;
  box-shadow: 0 4px 8px rgba(243, 156, 18, 0.3);
}
.StoreView_store-view-container__9lFDo .StoreView_global-search__wYMnE {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
  align-items: center;
  flex-wrap: wrap;
}
.StoreView_store-view-container__9lFDo .StoreView_global-search__wYMnE .StoreView_search-input__fPCTn {
  flex: 1 1;
  min-width: 300px;
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  background: white;
  transition: all 0.3s ease;
}
.StoreView_store-view-container__9lFDo .StoreView_global-search__wYMnE .StoreView_search-input__fPCTn:focus {
  outline: none;
  border-color: #3498db;
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);
}
.StoreView_store-view-container__9lFDo .StoreView_global-search__wYMnE .StoreView_search-input__fPCTn::placeholder {
  color: #a0aec0;
  font-style: italic;
}
.StoreView_store-view-container__9lFDo .StoreView_global-search__wYMnE .StoreView_clear-filters-btn__JBQvR {
  padding: 12px 20px;
  background: #e74c3c;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}
.StoreView_store-view-container__9lFDo .StoreView_global-search__wYMnE .StoreView_clear-filters-btn__JBQvR:hover {
  background: #c0392b;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(231, 76, 60, 0.3);
}
.StoreView_store-view-container__9lFDo .StoreView_filters-panel__l-YkG {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  margin-bottom: 20px;
  padding: 20px;
  animation: StoreView_slideDown__68H8j 0.3s ease-out;
}
.StoreView_store-view-container__9lFDo .StoreView_filters-panel__l-YkG .StoreView_filters-grid__\\+5QkJ {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}
.StoreView_store-view-container__9lFDo .StoreView_filters-panel__l-YkG .StoreView_filters-grid__\\+5QkJ .StoreView_filter-group__tF6GN {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.StoreView_store-view-container__9lFDo .StoreView_filters-panel__l-YkG .StoreView_filters-grid__\\+5QkJ .StoreView_filter-group__tF6GN label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 4px;
}
.StoreView_store-view-container__9lFDo .StoreView_filters-panel__l-YkG .StoreView_filters-grid__\\+5QkJ .StoreView_filter-group__tF6GN input {
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 0.9rem;
  background: white;
  transition: all 0.2s ease;
}
.StoreView_store-view-container__9lFDo .StoreView_filters-panel__l-YkG .StoreView_filters-grid__\\+5QkJ .StoreView_filter-group__tF6GN input:focus {
  outline: none;
  border-color: #3498db;
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);
}
.StoreView_store-view-container__9lFDo .StoreView_filters-panel__l-YkG .StoreView_filters-grid__\\+5QkJ .StoreView_filter-group__tF6GN input::placeholder {
  color: #a0aec0;
  font-style: italic;
}
.StoreView_store-view-container__9lFDo .StoreView_filters-panel__l-YkG .StoreView_filters-grid__\\+5QkJ .StoreView_filter-group__tF6GN input:hover {
  border-color: #cbd5e0;
}
@keyframes StoreView_slideDown__68H8j {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.StoreView_store-view-container__9lFDo .StoreView_table-wrapper__CXEp6 {
  height: calc(100vh - 200px);
  min-height: 400px;
  margin-bottom: 20px;
  position: relative;
}
.StoreView_store-view-container__9lFDo .StoreView_table-container__abwNu {
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  overflow: auto;
  height: 100%;
  border: 1px solid #e2e8f0;
  position: relative;
}
.StoreView_store-view-container__9lFDo .StoreView_table-container__abwNu::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #4a5568 0%, #2d3748 50%, #1a202c 100%);
  border-radius: 12px 12px 0 0;
  z-index: 10;
}
.StoreView_store-view-container__9lFDo .StoreView_table-container__abwNu::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}
.StoreView_store-view-container__9lFDo .StoreView_table-container__abwNu::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 6px;
}
.StoreView_store-view-container__9lFDo .StoreView_table-container__abwNu::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #cbd5e0 0%, #a0aec0 100%);
  border-radius: 6px;
  border: 2px solid #f1f5f9;
}
.StoreView_store-view-container__9lFDo .StoreView_table-container__abwNu::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #a0aec0 0%, #718096 100%);
}
.StoreView_store-view-container__9lFDo .StoreView_table-container__abwNu::-webkit-scrollbar-corner {
  background: #f1f5f9;
}
.StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
  min-width: 1200px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
}
.StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e th, .StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e td {
  border: 1px solid #e1e8ed;
  padding: 12px 8px;
  text-align: center;
  vertical-align: middle;
  word-wrap: break-word;
  max-width: 120px;
  position: relative;
}
.StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e .StoreView_main-header__\\+BrC6 th {
  background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%);
  font-weight: 700;
  font-size: 0.95rem;
  color: white;
  border-bottom: 2px solid #2d3748;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  padding: 16px 8px;
}
.StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e .StoreView_main-header__\\+BrC6 th:first-child {
  border-top: 2px solid #2d3748;
}
.StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e .StoreView_main-header__\\+BrC6 th:last-child {
  border-top: 2px solid #2d3748;
}
.StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e .StoreView_sub-header__4n28H th {
  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e0 100%);
  font-weight: 600;
  font-size: 0.85rem;
  color: #2d3748;
  border-bottom: 2px solid #a0aec0;
  padding: 14px 8px;
  border-top: 1px solid #cbd5e0;
}
.StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e .StoreView_column-numbers__P-aAO th {
  background: linear-gradient(135deg, #c6f6d5 0%, #9ae6b4 100%);
  font-weight: 700;
  font-size: 0.9rem;
  color: #22543d;
  font-family: "Noto Sans Devanagari", sans-serif;
  border-bottom: 2px solid #68d391;
  padding: 12px 8px;
  border-top: 1px solid #9ae6b4;
}
.StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e .StoreView_data-row__tTVOw {
  transition: all 0.2s ease-in-out;
}
.StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e .StoreView_data-row__tTVOw:nth-child(even) {
  background: #f7fafc;
}
.StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e .StoreView_data-row__tTVOw:nth-child(odd) {
  background: #ffffff;
}
.StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e .StoreView_data-row__tTVOw:hover {
  background: linear-gradient(135deg, #e6fffa 0%, #b2f5ea 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(72, 187, 120, 0.1);
}
.StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e .StoreView_data-row__tTVOw td {
  font-size: 0.8rem;
  color: #4a5568;
  border: 1px solid #e2e8f0;
  padding: 10px 8px;
  transition: all 0.2s ease;
}
.StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e .StoreView_data-row__tTVOw:hover td {
  border-color: #68d391;
}
.StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e .StoreView_no-data__xdrYT {
  text-align: center;
  padding: 60px 40px;
  font-style: italic;
  color: #718096;
  font-size: 1.1rem;
  background: linear-gradient(135deg, #f7fafc 0%, #e2e8f0 100%);
  border: 2px dashed #a0aec0;
  border-radius: 8px;
  margin: 20px;
}
.StoreView_store-view-container__9lFDo .StoreView_loading__-Wi6L, .StoreView_store-view-container__9lFDo .StoreView_error__7kJdg {
  text-align: center;
  padding: 40px;
  font-size: 1.2rem;
  color: #2c3e50;
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.StoreView_store-view-container__9lFDo .StoreView_error__7kJdg {
  color: #e74c3c;
}

.StoreView_pagination-container__W0Ggp {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  margin-top: 20px;
}
.StoreView_pagination-container__W0Ggp .StoreView_pagination-info__dU62W {
  font-size: 0.9rem;
  color: #4a5568;
  font-weight: 500;
}
.StoreView_pagination-container__W0Ggp .StoreView_pagination-info__dU62W .StoreView_filtered-info__EYeAR {
  color: #3498db;
  font-weight: 600;
  margin-left: 10px;
}
.StoreView_pagination-container__W0Ggp .StoreView_pagination-controls__HIzsP {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.StoreView_pagination-container__W0Ggp .StoreView_pagination-controls__HIzsP .StoreView_pagination-btn__Rljox {
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  background: white;
  color: #4a5568;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 40px;
  text-align: center;
}
.StoreView_pagination-container__W0Ggp .StoreView_pagination-controls__HIzsP .StoreView_pagination-btn__Rljox:hover:not(:disabled) {
  background: #f7fafc;
  border-color: #cbd5e0;
  color: #2d3748;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.StoreView_pagination-container__W0Ggp .StoreView_pagination-controls__HIzsP .StoreView_pagination-btn__Rljox:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: #f7fafc;
  color: #a0aec0;
}
.StoreView_pagination-container__W0Ggp .StoreView_pagination-controls__HIzsP .StoreView_pagination-btn__Rljox.StoreView_active__3pnLa {
  background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
  color: white;
  border-color: #2980b9;
  box-shadow: 0 2px 4px rgba(52, 152, 219, 0.3);
}
.StoreView_pagination-container__W0Ggp .StoreView_pagination-controls__HIzsP .StoreView_pagination-btn__Rljox.StoreView_active__3pnLa:hover {
  background: linear-gradient(135deg, #2980b9 0%, #1f5f8b 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(52, 152, 219, 0.4);
}
.StoreView_pagination-container__W0Ggp .StoreView_pagination-controls__HIzsP .StoreView_pagination-btn__Rljox.StoreView_disabled__DajO8 {
  opacity: 0.3;
  cursor: not-allowed;
  background: #f7fafc;
  color: #a0aec0;
  border-color: #e2e8f0;
}

@media (max-width: 1200px) {
  .StoreView_store-view-container__9lFDo {
    padding: 10px;
  }
  .StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq h2 {
    font-size: 1.5rem;
  }
  .StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 {
    gap: 8px;
  }
  .StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 .StoreView_refresh-btn__Zju0k,
  .StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 .StoreView_print-btn__mx6fB,
  .StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 .StoreView_filter-btn__RFeYq,
  .StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 .StoreView_excel-btn__W9QQb {
    padding: 8px 16px;
    font-size: 0.9rem;
  }
  .StoreView_store-view-container__9lFDo .StoreView_global-search__wYMnE {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  .StoreView_store-view-container__9lFDo .StoreView_global-search__wYMnE .StoreView_search-input__fPCTn {
    min-width: auto;
  }
  .StoreView_store-view-container__9lFDo .StoreView_filters-panel__l-YkG {
    padding: 15px;
  }
  .StoreView_store-view-container__9lFDo .StoreView_filters-panel__l-YkG .StoreView_filters-grid__\\+5QkJ {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  .StoreView_store-view-container__9lFDo .StoreView_table-container__abwNu {
    border-radius: 8px;
  }
  .StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e {
    font-size: 0.75rem;
    min-width: 1000px;
  }
  .StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e th, .StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e td {
    padding: 8px 6px;
    max-width: 100px;
  }
  .StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e .StoreView_main-header__\\+BrC6 th {
    padding: 12px 6px;
  }
  .StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e .StoreView_sub-header__4n28H th {
    padding: 10px 6px;
  }
  .StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e .StoreView_column-numbers__P-aAO th {
    padding: 8px 6px;
  }
}
@media (max-width: 768px) {
  .StoreView_store-view-container__9lFDo {
    padding: 5px;
  }
  .StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq h2 {
    font-size: 1.3rem;
    margin-bottom: 0;
  }
  .StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 {
    gap: 6px;
  }
  .StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 .StoreView_refresh-btn__Zju0k,
  .StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 .StoreView_print-btn__mx6fB,
  .StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 .StoreView_filter-btn__RFeYq,
  .StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq .StoreView_header-buttons__YMWk0 .StoreView_excel-btn__W9QQb {
    padding: 6px 12px;
    font-size: 0.8rem;
  }
  .StoreView_store-view-container__9lFDo .StoreView_global-search__wYMnE .StoreView_search-input__fPCTn {
    font-size: 0.9rem;
    padding: 10px 12px;
  }
  .StoreView_store-view-container__9lFDo .StoreView_global-search__wYMnE .StoreView_clear-filters-btn__JBQvR {
    padding: 10px 16px;
    font-size: 0.9rem;
  }
  .StoreView_store-view-container__9lFDo .StoreView_filters-panel__l-YkG {
    padding: 10px;
  }
  .StoreView_store-view-container__9lFDo .StoreView_filters-panel__l-YkG .StoreView_filters-grid__\\+5QkJ {
    gap: 10px;
  }
  .StoreView_store-view-container__9lFDo .StoreView_filters-panel__l-YkG .StoreView_filters-grid__\\+5QkJ .StoreView_filter-group__tF6GN input {
    padding: 8px 10px;
    font-size: 0.85rem;
  }
  .StoreView_store-view-container__9lFDo .StoreView_filters-panel__l-YkG .StoreView_filters-grid__\\+5QkJ .StoreView_filter-group__tF6GN label {
    font-size: 0.85rem;
  }
  .StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e {
    font-size: 0.7rem;
    min-width: 800px;
  }
  .StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e th, .StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e td {
    padding: 6px 4px;
    max-width: 80px;
  }
  .StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e .StoreView_main-header__\\+BrC6 th {
    font-size: 0.8rem;
    padding: 10px 4px;
  }
  .StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e .StoreView_sub-header__4n28H th {
    font-size: 0.7rem;
    padding: 8px 4px;
  }
  .StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e .StoreView_column-numbers__P-aAO th {
    font-size: 0.8rem;
    padding: 6px 4px;
  }
  .StoreView_pagination-container__W0Ggp {
    flex-direction: column;
    gap: 15px;
    padding: 15px;
  }
  .StoreView_pagination-container__W0Ggp .StoreView_pagination-controls__HIzsP {
    justify-content: center;
    gap: 6px;
  }
  .StoreView_pagination-container__W0Ggp .StoreView_pagination-controls__HIzsP .StoreView_pagination-btn__Rljox {
    padding: 6px 10px;
    font-size: 0.8rem;
    min-width: 35px;
  }
}
@media (max-width: 480px) {
  .StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e {
    font-size: 0.65rem;
    min-width: 600px;
  }
  .StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e th, .StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e td {
    padding: 3px 1px;
    max-width: 60px;
  }
}
@media print {
  * {
    print-color-adjust: exact !important;
  }
  .StoreView_store-view-container__9lFDo {
    background: white !important;
    padding: 20px !important;
    max-width: none !important;
  }
  .StoreView_store-view-container__9lFDo .StoreView_view-header__OiMVq {
    display: none !important;
  }
  .StoreView_store-view-container__9lFDo .StoreView_global-search__wYMnE {
    display: none !important;
  }
  .StoreView_store-view-container__9lFDo .StoreView_filters-panel__l-YkG {
    display: none !important;
  }
  .StoreView_store-view-container__9lFDo .StoreView_table-wrapper__CXEp6 {
    height: auto !important;
    min-height: auto !important;
  }
  .StoreView_store-view-container__9lFDo .StoreView_table-container__abwNu {
    background: white !important;
    border-radius: 12px !important;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08) !important;
    overflow-x: visible !important;
    margin-bottom: 30px !important;
    border: 1px solid #e2e8f0 !important;
    position: relative !important;
  }
  .StoreView_store-view-container__9lFDo .StoreView_table-container__abwNu::before {
    content: "" !important;
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    height: 4px !important;
    background: linear-gradient(90deg, #4a5568 0%, #2d3748 50%, #1a202c 100%) !important;
    border-radius: 12px 12px 0 0 !important;
  }
  .StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e {
    width: 100% !important;
    border-collapse: collapse !important;
    font-size: 0.85rem !important;
    min-width: 1200px !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
    border-radius: 8px !important;
    overflow: hidden !important;
  }
  .StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e th, .StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e td {
    border: 1px solid #e1e8ed !important;
    padding: 12px 8px !important;
    text-align: center !important;
    vertical-align: middle !important;
    word-wrap: break-word !important;
    max-width: 120px !important;
    position: relative !important;
  }
  .StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e .StoreView_main-header__\\+BrC6 th {
    background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%) !important;
    font-weight: 700 !important;
    font-size: 0.95rem !important;
    color: white !important;
    border-bottom: 2px solid #2d3748 !important;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2) !important;
    padding: 16px 8px !important;
  }
  .StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e .StoreView_main-header__\\+BrC6 th:first-child {
    border-top: 2px solid #2d3748 !important;
  }
  .StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e .StoreView_main-header__\\+BrC6 th:last-child {
    border-top: 2px solid #2d3748 !important;
  }
  .StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e .StoreView_sub-header__4n28H th {
    background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e0 100%) !important;
    font-weight: 600 !important;
    font-size: 0.85rem !important;
    color: #2d3748 !important;
    border-bottom: 2px solid #a0aec0 !important;
    padding: 14px 8px !important;
    border-top: 1px solid #cbd5e0 !important;
  }
  .StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e .StoreView_column-numbers__P-aAO th {
    background: linear-gradient(135deg, #c6f6d5 0%, #9ae6b4 100%) !important;
    font-weight: 700 !important;
    font-size: 0.9rem !important;
    color: #22543d !important;
    font-family: "Noto Sans Devanagari", sans-serif !important;
    border-bottom: 2px solid #68d391 !important;
    padding: 12px 8px !important;
    border-top: 1px solid #9ae6b4 !important;
  }
  .StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e .StoreView_data-row__tTVOw {
    transition: none !important;
  }
  .StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e .StoreView_data-row__tTVOw:nth-child(even) {
    background: #f7fafc !important;
  }
  .StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e .StoreView_data-row__tTVOw:nth-child(odd) {
    background: #ffffff !important;
  }
  .StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e .StoreView_data-row__tTVOw:hover {
    background: #f7fafc !important;
    transform: none !important;
    box-shadow: none !important;
  }
  .StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e .StoreView_data-row__tTVOw td {
    font-size: 0.8rem !important;
    color: #4a5568 !important;
    border: 1px solid #e2e8f0 !important;
    padding: 10px 8px !important;
    transition: none !important;
  }
  .StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e .StoreView_data-row__tTVOw:hover td {
    border-color: #e2e8f0 !important;
  }
  .StoreView_store-view-container__9lFDo .StoreView_store-table__OSA5e .StoreView_no-data__xdrYT {
    text-align: center !important;
    padding: 60px 40px !important;
    font-style: italic !important;
    color: #718096 !important;
    font-size: 1.1rem !important;
    background: linear-gradient(135deg, #f7fafc 0%, #e2e8f0 100%) !important;
    border: 2px dashed #a0aec0 !important;
    border-radius: 8px !important;
    margin: 20px !important;
  }
  .StoreView_pagination-container__W0Ggp {
    display: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/store-view/StoreView.module.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,cAAA;EACA,aAAA;EACA,4DAAA;EACA,mBAAA;EACA,iBAAA;AACJ;AACI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AACR;AACQ;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AACZ;AAEQ;EACI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AAAZ;AAEY;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AAAhB;AAEgB;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAApB;AAGgB;EACI,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;AADpB;AAGoB;EACI,aAAA;EACA,qBAAA;EACA,6CAAA;AADxB;AAIoB;EACI,qBAAA;AAFxB;AAOY;;;;EAII,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AALhB;AAOgB;;;;EACI,2BAAA;EACA,wCAAA;AAFpB;AAMY;EACI,mBAAA;EACA,YAAA;AAJhB;AAMgB;EACI,mBAAA;EACA,6CAAA;AAJpB;AAQY;EACI,mBAAA;EACA,YAAA;AANhB;AAQgB;EACI,mBAAA;EACA,4CAAA;AANpB;AAUY;EACI,mBAAA;EACA,YAAA;AARhB;AAUgB;EACI,mBAAA;EACA,6CAAA;AARpB;AAYY;EACI,mBAAA;EACA,YAAA;AAVhB;AAYgB;EACI,mBAAA;EACA,6CAAA;AAVpB;AAiBI;EACI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AAfR;AAiBQ;EACI,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AAfZ;AAiBY;EACI,aAAA;EACA,qBAAA;EACA,6CAAA;AAfhB;AAkBY;EACI,cAAA;EACA,kBAAA;AAhBhB;AAoBQ;EACI,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAlBZ;AAoBY;EACI,mBAAA;EACA,2BAAA;EACA,4CAAA;AAlBhB;AAwBI;EACI,iBAAA;EACA,mBAAA;EACA,0CAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,mDAAA;AAtBR;AAwBQ;EACI,aAAA;EACA,2DAAA;EACA,SAAA;AAtBZ;AAwBY;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AAtBhB;AAwBgB;EACI,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAtBpB;AAyBgB;EACI,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;AAvBpB;AAyBoB;EACI,aAAA;EACA,qBAAA;EACA,6CAAA;AAvBxB;AA0BoB;EACI,cAAA;EACA,kBAAA;AAxBxB;AA2BoB;EACI,qBAAA;AAzBxB;AAgCI;EACI;IACI,UAAA;IACA,4BAAA;EA9BV;EAgCM;IACI,UAAA;IACA,wBAAA;EA9BV;AACF;AAiCI;EACI,2BAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AA/BR;AAkCI;EACI,iBAAA;EACA,mBAAA;EACA,0CAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AAhCR;AAkCQ;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,yEAAA;EACA,4BAAA;EACA,WAAA;AAhCZ;AAoCQ;EACI,WAAA;EACA,YAAA;AAlCZ;AAqCQ;EACI,mBAAA;EACA,kBAAA;AAnCZ;AAsCQ;EACI,6DAAA;EACA,kBAAA;EACA,yBAAA;AApCZ;AAsCY;EACI,6DAAA;AApChB;AAwCQ;EACI,mBAAA;AAtCZ;AA0CI;EACI,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;AAxCR;AA0CQ;EACI,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AAxCZ;AA4CY;EACI,6DAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,gCAAA;EACA,yCAAA;EACA,iBAAA;AA1ChB;AA4CgB;EACI,6BAAA;AA1CpB;AA4CgB;EACI,6BAAA;AA1CpB;AAgDY;EACI,6DAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,gCAAA;EACA,iBAAA;EACA,6BAAA;AA9ChB;AAmDY;EACI,6DAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,+CAAA;EACA,gCAAA;EACA,iBAAA;EACA,6BAAA;AAjDhB;AAqDQ;EACI,gCAAA;AAnDZ;AAqDY;EACI,mBAAA;AAnDhB;AAsDY;EACI,mBAAA;AApDhB;AAuDY;EACI,6DAAA;EACA,2BAAA;EACA,8CAAA;AArDhB;AAwDY;EACI,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,yBAAA;AAtDhB;AAyDY;EACI,qBAAA;AAvDhB;AA2DQ;EACI,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,6DAAA;EACA,0BAAA;EACA,kBAAA;EACA,YAAA;AAzDZ;AA6DI;EACI,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,wCAAA;AA3DR;AA8DI;EACI,cAAA;AA5DR;;AAiEA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,0CAAA;EACA,yBAAA;EACA,gBAAA;AA9DJ;AAgEI;EACI,iBAAA;EACA,cAAA;EACA,gBAAA;AA9DR;AAgEQ;EACI,cAAA;EACA,gBAAA;EACA,iBAAA;AA9DZ;AAkEI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAhER;AAkEQ;EACI,iBAAA;EACA,yBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;AAhEZ;AAkEY;EACI,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,2BAAA;EACA,wCAAA;AAhEhB;AAmEY;EACI,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;AAjEhB;AAoEY;EACI,6DAAA;EACA,YAAA;EACA,qBAAA;EACA,6CAAA;AAlEhB;AAoEgB;EACI,6DAAA;EACA,2BAAA;EACA,6CAAA;AAlEpB;AAsEY;EACI,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,qBAAA;AApEhB;;AA2EA;EACI;IACI,aAAA;EAxEN;EA2EU;IACI,iBAAA;EAzEd;EA4EU;IACI,QAAA;EA1Ed;EA4Ec;;;;IAII,iBAAA;IACA,iBAAA;EA1ElB;EA+EM;IACI,sBAAA;IACA,oBAAA;IACA,SAAA;EA7EV;EA+EU;IACI,eAAA;EA7Ed;EAiFM;IACI,aAAA;EA/EV;EAiFU;IACI,0BAAA;IACA,SAAA;EA/Ed;EAmFM;IACI,kBAAA;EAjFV;EAoFM;IACI,kBAAA;IACA,iBAAA;EAlFV;EAoFU;IACI,gBAAA;IACA,gBAAA;EAlFd;EAqFU;IACI,iBAAA;EAnFd;EAsFU;IACI,iBAAA;EApFd;EAuFU;IACI,gBAAA;EArFd;AACF;AA0FA;EACI;IACI,YAAA;EAxFN;EA0FM;IACI,sBAAA;IACA,uBAAA;IACA,SAAA;EAxFV;EA0FU;IACI,iBAAA;IACA,gBAAA;EAxFd;EA2FU;IACI,QAAA;EAzFd;EA2Fc;;;;IAII,iBAAA;IACA,iBAAA;EAzFlB;EA+FU;IACI,iBAAA;IACA,kBAAA;EA7Fd;EAgGU;IACI,kBAAA;IACA,iBAAA;EA9Fd;EAkGM;IACI,aAAA;EAhGV;EAkGU;IACI,SAAA;EAhGd;EAmGkB;IACI,iBAAA;IACA,kBAAA;EAjGtB;EAoGkB;IACI,kBAAA;EAlGtB;EAwGM;IACI,iBAAA;IACA,gBAAA;EAtGV;EAwGU;IACI,gBAAA;IACA,eAAA;EAtGd;EAyGU;IACI,iBAAA;IACA,iBAAA;EAvGd;EA0GU;IACI,iBAAA;IACA,gBAAA;EAxGd;EA2GU;IACI,iBAAA;IACA,gBAAA;EAzGd;EA8GE;IACI,sBAAA;IACA,SAAA;IACA,aAAA;EA5GN;EA8GM;IACI,uBAAA;IACA,QAAA;EA5GV;EA8GU;IACI,iBAAA;IACA,iBAAA;IACA,eAAA;EA5Gd;AACF;AAiHA;EAEQ;IACI,kBAAA;IACA,gBAAA;EAhHV;EAkHU;IACI,gBAAA;IACA,eAAA;EAhHd;AACF;AAsHA;EACI;IAEI,oCAAA;EApHN;EAuHE;IACI,4BAAA;IACA,wBAAA;IACA,0BAAA;EArHN;EAuHM;IACI,wBAAA;EArHV;EAwHM;IACI,wBAAA;EAtHV;EAyHM;IACI,wBAAA;EAvHV;EA0HM;IACI,uBAAA;IACA,2BAAA;EAxHV;EA2HM;IACI,4BAAA;IACA,8BAAA;IACA,qDAAA;IACA,8BAAA;IACA,8BAAA;IACA,oCAAA;IACA,6BAAA;EAzHV;EA2HU;IACI,sBAAA;IACA,6BAAA;IACA,iBAAA;IACA,kBAAA;IACA,mBAAA;IACA,sBAAA;IACA,oFAAA;IACA,uCAAA;EAzHd;EA6HM;IACI,sBAAA;IACA,oCAAA;IACA,6BAAA;IACA,4BAAA;IACA,mDAAA;IACA,6BAAA;IACA,2BAAA;EA3HV;EA6HU;IACI,oCAAA;IACA,4BAAA;IACA,6BAAA;IACA,iCAAA;IACA,gCAAA;IACA,2BAAA;IACA,6BAAA;EA3Hd;EA+Hc;IACI,wEAAA;IACA,2BAAA;IACA,6BAAA;IACA,uBAAA;IACA,2CAAA;IACA,oDAAA;IACA,4BAAA;EA7HlB;EA+HkB;IACI,wCAAA;EA7HtB;EA+HkB;IACI,wCAAA;EA7HtB;EAmIc;IACI,wEAAA;IACA,2BAAA;IACA,6BAAA;IACA,yBAAA;IACA,2CAAA;IACA,4BAAA;IACA,wCAAA;EAjIlB;EAsIc;IACI,wEAAA;IACA,2BAAA;IACA,4BAAA;IACA,yBAAA;IACA,0DAAA;IACA,2CAAA;IACA,4BAAA;IACA,wCAAA;EApIlB;EAwIU;IACI,2BAAA;EAtId;EAwIc;IACI,8BAAA;EAtIlB;EAyIc;IACI,8BAAA;EAvIlB;EA0Ic;IACI,8BAAA;IACA,0BAAA;IACA,2BAAA;EAxIlB;EA2Ic;IACI,4BAAA;IACA,yBAAA;IACA,oCAAA;IACA,4BAAA;IACA,2BAAA;EAzIlB;EA4Ic;IACI,gCAAA;EA1IlB;EA8IU;IACI,6BAAA;IACA,6BAAA;IACA,6BAAA;IACA,yBAAA;IACA,4BAAA;IACA,wEAAA;IACA,qCAAA;IACA,6BAAA;IACA,uBAAA;EA5Id;EAiJE;IACI,wBAAA;EA/IN;AACF","sourcesContent":[".store-view-container {\n    max-width: 1400px;\n    margin: 0 auto;\n    padding: 20px;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    background: #f8f9fa;\n    min-height: 100vh;\n\n    .view-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 20px;\n        flex-wrap: wrap;\n        gap: 15px;\n\n        h2 {\n            color: #2c3e50;\n            font-size: 2rem;\n            font-weight: 600;\n            margin: 0;\n        }\n\n        .header-buttons {\n            display: flex;\n            gap: 10px;\n            align-items: center;\n            flex-wrap: wrap;\n\n            .pagination-controls {\n                display: flex;\n                align-items: center;\n                gap: 10px;\n\n                label {\n                    display: flex;\n                    align-items: center;\n                    gap: 8px;\n                    font-size: 0.9rem;\n                    color: #4a5568;\n                    font-weight: 500;\n                }\n\n                .items-per-page {\n                    padding: 6px 12px;\n                    border: 1px solid #e2e8f0;\n                    border-radius: 6px;\n                    background: white;\n                    font-size: 0.9rem;\n                    color: #2d3748;\n                    cursor: pointer;\n                    transition: all 0.2s ease;\n\n                    &:focus {\n                        outline: none;\n                        border-color: #3498db;\n                        box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);\n                    }\n\n                    &:hover {\n                        border-color: #cbd5e0;\n                    }\n                }\n            }\n\n            .refresh-btn,\n            .print-btn,\n            .filter-btn,\n            .excel-btn {\n                padding: 10px 20px;\n                border: none;\n                border-radius: 6px;\n                font-size: 1rem;\n                font-weight: 600;\n                cursor: pointer;\n                transition: all 0.3s ease;\n                display: flex;\n                align-items: center;\n                gap: 8px;\n\n                &:hover {\n                    transform: translateY(-1px);\n                    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n                }\n            }\n\n            .refresh-btn {\n                background: #3498db;\n                color: white;\n\n                &:hover {\n                    background: #2980b9;\n                    box-shadow: 0 4px 8px rgba(52, 152, 219, 0.3);\n                }\n            }\n\n            .print-btn {\n                background: #27ae60;\n                color: white;\n\n                &:hover {\n                    background: #229954;\n                    box-shadow: 0 4px 8px rgba(39, 174, 96, 0.3);\n                }\n            }\n\n            .filter-btn {\n                background: #9b59b6;\n                color: white;\n\n                &:hover {\n                    background: #8e44ad;\n                    box-shadow: 0 4px 8px rgba(155, 89, 182, 0.3);\n                }\n            }\n\n            .excel-btn {\n                background: #f39c12;\n                color: white;\n\n                &:hover {\n                    background: #e67e22;\n                    box-shadow: 0 4px 8px rgba(243, 156, 18, 0.3);\n                }\n            }\n        }\n    }\n\n    // Global Search\n    .global-search {\n        display: flex;\n        gap: 15px;\n        margin-bottom: 20px;\n        align-items: center;\n        flex-wrap: wrap;\n\n        .search-input {\n            flex: 1;\n            min-width: 300px;\n            padding: 12px 16px;\n            border: 2px solid #e2e8f0;\n            border-radius: 8px;\n            font-size: 1rem;\n            background: white;\n            transition: all 0.3s ease;\n\n            &:focus {\n                outline: none;\n                border-color: #3498db;\n                box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);\n            }\n\n            &::placeholder {\n                color: #a0aec0;\n                font-style: italic;\n            }\n        }\n\n        .clear-filters-btn {\n            padding: 12px 20px;\n            background: #e74c3c;\n            color: white;\n            border: none;\n            border-radius: 8px;\n            font-size: 1rem;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.3s ease;\n            display: flex;\n            align-items: center;\n            gap: 8px;\n\n            &:hover {\n                background: #c0392b;\n                transform: translateY(-1px);\n                box-shadow: 0 4px 8px rgba(231, 76, 60, 0.3);\n            }\n        }\n    }\n\n    // Advanced Filters Panel\n    .filters-panel {\n        background: white;\n        border-radius: 12px;\n        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);\n        border: 1px solid #e2e8f0;\n        margin-bottom: 20px;\n        padding: 20px;\n        animation: slideDown 0.3s ease-out;\n\n        .filters-grid {\n            display: grid;\n            grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n            gap: 20px;\n\n            .filter-group {\n                display: flex;\n                flex-direction: column;\n                gap: 8px;\n\n                label {\n                    font-size: 0.9rem;\n                    font-weight: 600;\n                    color: #2d3748;\n                    margin-bottom: 4px;\n                }\n\n                input {\n                    padding: 10px 12px;\n                    border: 1px solid #e2e8f0;\n                    border-radius: 6px;\n                    font-size: 0.9rem;\n                    background: white;\n                    transition: all 0.2s ease;\n\n                    &:focus {\n                        outline: none;\n                        border-color: #3498db;\n                        box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);\n                    }\n\n                    &::placeholder {\n                        color: #a0aec0;\n                        font-style: italic;\n                    }\n\n                    &:hover {\n                        border-color: #cbd5e0;\n                    }\n                }\n            }\n        }\n    }\n\n    @keyframes slideDown {\n        from {\n            opacity: 0;\n            transform: translateY(-20px);\n        }\n        to {\n            opacity: 1;\n            transform: translateY(0);\n        }\n    }\n\n    .table-wrapper {\n        height: calc(100vh - 200px);\n        min-height: 400px;\n        margin-bottom: 20px;\n        position: relative;\n    }\n\n    .table-container {\n        background: white;\n        border-radius: 12px;\n        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);\n        overflow: auto;\n        height: 100%;\n        border: 1px solid #e2e8f0;\n        position: relative;\n        \n        &::before {\n            content: '';\n            position: absolute;\n            top: 0;\n            left: 0;\n            right: 0;\n            height: 4px;\n            background: linear-gradient(90deg, #4a5568 0%, #2d3748 50%, #1a202c 100%);\n            border-radius: 12px 12px 0 0;\n            z-index: 10;\n        }\n\n        // Custom scrollbar styles\n        &::-webkit-scrollbar {\n            width: 12px;\n            height: 12px;\n        }\n\n        &::-webkit-scrollbar-track {\n            background: #f1f5f9;\n            border-radius: 6px;\n        }\n\n        &::-webkit-scrollbar-thumb {\n            background: linear-gradient(135deg, #cbd5e0 0%, #a0aec0 100%);\n            border-radius: 6px;\n            border: 2px solid #f1f5f9;\n\n            &:hover {\n                background: linear-gradient(135deg, #a0aec0 0%, #718096 100%);\n            }\n        }\n\n        &::-webkit-scrollbar-corner {\n            background: #f1f5f9;\n        }\n    }\n\n    .store-table {\n        width: 100%;\n        border-collapse: collapse;\n        font-size: 0.85rem;\n        min-width: 1200px;\n        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n        border-radius: 8px;\n        overflow: hidden;\n\n        th, td {\n            border: 1px solid #e1e8ed;\n            padding: 12px 8px;\n            text-align: center;\n            vertical-align: middle;\n            word-wrap: break-word;\n            max-width: 120px;\n            position: relative;\n        }\n\n        .main-header {\n            th {\n                background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%);\n                font-weight: 700;\n                font-size: 0.95rem;\n                color: white;\n                border-bottom: 2px solid #2d3748;\n                text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n                padding: 16px 8px;\n                \n                &:first-child {\n                    border-top: 2px solid #2d3748;\n                }\n                &:last-child {\n                    border-top: 2px solid #2d3748;\n                }\n            }\n        }\n\n        .sub-header {\n            th {\n                background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e0 100%);\n                font-weight: 600;\n                font-size: 0.85rem;\n                color: #2d3748;\n                border-bottom: 2px solid #a0aec0;\n                padding: 14px 8px;\n                border-top: 1px solid #cbd5e0;\n            }\n        }\n\n        .column-numbers {\n            th {\n                background: linear-gradient(135deg, #c6f6d5 0%, #9ae6b4 100%);\n                font-weight: 700;\n                font-size: 0.9rem;\n                color: #22543d;\n                font-family: 'Noto Sans Devanagari', sans-serif;\n                border-bottom: 2px solid #68d391;\n                padding: 12px 8px;\n                border-top: 1px solid #9ae6b4;\n            }\n        }\n\n        .data-row {\n            transition: all 0.2s ease-in-out;\n            \n            &:nth-child(even) {\n                background: #f7fafc;\n            }\n\n            &:nth-child(odd) {\n                background: #ffffff;\n            }\n\n            &:hover {\n                background: linear-gradient(135deg, #e6fffa 0%, #b2f5ea 100%);\n                transform: translateY(-1px);\n                box-shadow: 0 4px 12px rgba(72, 187, 120, 0.1);\n            }\n\n            td {\n                font-size: 0.8rem;\n                color: #4a5568;\n                border: 1px solid #e2e8f0;\n                padding: 10px 8px;\n                transition: all 0.2s ease;\n            }\n\n            &:hover td {\n                border-color: #68d391;\n            }\n        }\n\n        .no-data {\n            text-align: center;\n            padding: 60px 40px;\n            font-style: italic;\n            color: #718096;\n            font-size: 1.1rem;\n            background: linear-gradient(135deg, #f7fafc 0%, #e2e8f0 100%);\n            border: 2px dashed #a0aec0;\n            border-radius: 8px;\n            margin: 20px;\n        }\n    }\n\n    .loading, .error {\n        text-align: center;\n        padding: 40px;\n        font-size: 1.2rem;\n        color: #2c3e50;\n        background: white;\n        border-radius: 10px;\n        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    }\n\n    .error {\n        color: #e74c3c;\n    }\n}\n\n// Pagination Styles\n.pagination-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px;\n    background: white;\n    border-radius: 12px;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);\n    border: 1px solid #e2e8f0;\n    margin-top: 20px;\n\n    .pagination-info {\n        font-size: 0.9rem;\n        color: #4a5568;\n        font-weight: 500;\n\n        .filtered-info {\n            color: #3498db;\n            font-weight: 600;\n            margin-left: 10px;\n        }\n    }\n\n    .pagination-controls {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        flex-wrap: wrap;\n\n        .pagination-btn {\n            padding: 8px 12px;\n            border: 1px solid #e2e8f0;\n            background: white;\n            color: #4a5568;\n            border-radius: 6px;\n            font-size: 0.9rem;\n            font-weight: 500;\n            cursor: pointer;\n            transition: all 0.2s ease;\n            min-width: 40px;\n            text-align: center;\n\n            &:hover:not(:disabled) {\n                background: #f7fafc;\n                border-color: #cbd5e0;\n                color: #2d3748;\n                transform: translateY(-1px);\n                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n            }\n\n            &:disabled {\n                opacity: 0.5;\n                cursor: not-allowed;\n                background: #f7fafc;\n                color: #a0aec0;\n            }\n\n            &.active {\n                background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);\n                color: white;\n                border-color: #2980b9;\n                box-shadow: 0 2px 4px rgba(52, 152, 219, 0.3);\n\n                &:hover {\n                    background: linear-gradient(135deg, #2980b9 0%, #1f5f8b 100%);\n                    transform: translateY(-1px);\n                    box-shadow: 0 4px 8px rgba(52, 152, 219, 0.4);\n                }\n            }\n\n            &.disabled {\n                opacity: 0.3;\n                cursor: not-allowed;\n                background: #f7fafc;\n                color: #a0aec0;\n                border-color: #e2e8f0;\n            }\n        }\n    }\n}\n\n// Responsive Styles\n@media (max-width: 1200px) {\n    .store-view-container {\n        padding: 10px;\n\n        .view-header {\n            h2 {\n                font-size: 1.5rem;\n            }\n\n            .header-buttons {\n                gap: 8px;\n\n                .refresh-btn,\n                .print-btn,\n                .filter-btn,\n                .excel-btn {\n                    padding: 8px 16px;\n                    font-size: 0.9rem;\n                }\n            }\n        }\n\n        .global-search {\n            flex-direction: column;\n            align-items: stretch;\n            gap: 10px;\n\n            .search-input {\n                min-width: auto;\n            }\n        }\n\n        .filters-panel {\n            padding: 15px;\n\n            .filters-grid {\n                grid-template-columns: 1fr;\n                gap: 15px;\n            }\n        }\n\n        .table-container {\n            border-radius: 8px;\n        }\n\n        .store-table {\n            font-size: 0.75rem;\n            min-width: 1000px;\n\n            th, td {\n                padding: 8px 6px;\n                max-width: 100px;\n            }\n\n            .main-header th {\n                padding: 12px 6px;\n            }\n\n            .sub-header th {\n                padding: 10px 6px;\n            }\n\n            .column-numbers th {\n                padding: 8px 6px;\n            }\n        }\n    }\n}\n\n@media (max-width: 768px) {\n    .store-view-container {\n        padding: 5px;\n\n        .view-header {\n            flex-direction: column;\n            align-items: flex-start;\n            gap: 10px;\n\n            h2 {\n                font-size: 1.3rem;\n                margin-bottom: 0;\n            }\n\n            .header-buttons {\n                gap: 6px;\n\n                .refresh-btn,\n                .print-btn,\n                .filter-btn,\n                .excel-btn {\n                    padding: 6px 12px;\n                    font-size: 0.8rem;\n                }\n            }\n        }\n\n        .global-search {\n            .search-input {\n                font-size: 0.9rem;\n                padding: 10px 12px;\n            }\n\n            .clear-filters-btn {\n                padding: 10px 16px;\n                font-size: 0.9rem;\n            }\n        }\n\n        .filters-panel {\n            padding: 10px;\n\n            .filters-grid {\n                gap: 10px;\n\n                .filter-group {\n                    input {\n                        padding: 8px 10px;\n                        font-size: 0.85rem;\n                    }\n\n                    label {\n                        font-size: 0.85rem;\n                    }\n                }\n            }\n        }\n\n        .store-table {\n            font-size: 0.7rem;\n            min-width: 800px;\n\n            th, td {\n                padding: 6px 4px;\n                max-width: 80px;\n            }\n\n            .main-header th {\n                font-size: 0.8rem;\n                padding: 10px 4px;\n            }\n\n            .sub-header th {\n                font-size: 0.7rem;\n                padding: 8px 4px;\n            }\n\n            .column-numbers th {\n                font-size: 0.8rem;\n                padding: 6px 4px;\n            }\n        }\n    }\n\n    .pagination-container {\n        flex-direction: column;\n        gap: 15px;\n        padding: 15px;\n\n        .pagination-controls {\n            justify-content: center;\n            gap: 6px;\n\n            .pagination-btn {\n                padding: 6px 10px;\n                font-size: 0.8rem;\n                min-width: 35px;\n            }\n        }\n    }\n}\n\n@media (max-width: 480px) {\n    .store-view-container {\n        .store-table {\n            font-size: 0.65rem;\n            min-width: 600px;\n\n            th, td {\n                padding: 3px 1px;\n                max-width: 60px;\n            }\n        }\n    }\n}\n\n// Print Styles\n@media print {\n    * {\n        -webkit-print-color-adjust: exact !important;\n        print-color-adjust: exact !important;\n    }\n    \n    .store-view-container {\n        background: white !important;\n        padding: 20px !important;\n        max-width: none !important;\n\n        .view-header {\n            display: none !important;\n        }\n\n        .global-search {\n            display: none !important;\n        }\n\n        .filters-panel {\n            display: none !important;\n        }\n\n        .table-wrapper {\n            height: auto !important;\n            min-height: auto !important;\n        }\n\n        .table-container {\n            background: white !important;\n            border-radius: 12px !important;\n            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08) !important;\n            overflow-x: visible !important;\n            margin-bottom: 30px !important;\n            border: 1px solid #e2e8f0 !important;\n            position: relative !important;\n            \n            &::before {\n                content: '' !important;\n                position: absolute !important;\n                top: 0 !important;\n                left: 0 !important;\n                right: 0 !important;\n                height: 4px !important;\n                background: linear-gradient(90deg, #4a5568 0%, #2d3748 50%, #1a202c 100%) !important;\n                border-radius: 12px 12px 0 0 !important;\n            }\n        }\n\n        .store-table {\n            width: 100% !important;\n            border-collapse: collapse !important;\n            font-size: 0.85rem !important;\n            min-width: 1200px !important;\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;\n            border-radius: 8px !important;\n            overflow: hidden !important;\n\n            th, td {\n                border: 1px solid #e1e8ed !important;\n                padding: 12px 8px !important;\n                text-align: center !important;\n                vertical-align: middle !important;\n                word-wrap: break-word !important;\n                max-width: 120px !important;\n                position: relative !important;\n            }\n\n            .main-header {\n                th {\n                    background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%) !important;\n                    font-weight: 700 !important;\n                    font-size: 0.95rem !important;\n                    color: white !important;\n                    border-bottom: 2px solid #2d3748 !important;\n                    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2) !important;\n                    padding: 16px 8px !important;\n                    \n                    &:first-child {\n                        border-top: 2px solid #2d3748 !important;\n                    }\n                    &:last-child {\n                        border-top: 2px solid #2d3748 !important;\n                    }\n                }\n            }\n\n            .sub-header {\n                th {\n                    background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e0 100%) !important;\n                    font-weight: 600 !important;\n                    font-size: 0.85rem !important;\n                    color: #2d3748 !important;\n                    border-bottom: 2px solid #a0aec0 !important;\n                    padding: 14px 8px !important;\n                    border-top: 1px solid #cbd5e0 !important;\n                }\n            }\n\n            .column-numbers {\n                th {\n                    background: linear-gradient(135deg, #c6f6d5 0%, #9ae6b4 100%) !important;\n                    font-weight: 700 !important;\n                    font-size: 0.9rem !important;\n                    color: #22543d !important;\n                    font-family: 'Noto Sans Devanagari', sans-serif !important;\n                    border-bottom: 2px solid #68d391 !important;\n                    padding: 12px 8px !important;\n                    border-top: 1px solid #9ae6b4 !important;\n                }\n            }\n\n            .data-row {\n                transition: none !important;\n                \n                &:nth-child(even) {\n                    background: #f7fafc !important;\n                }\n\n                &:nth-child(odd) {\n                    background: #ffffff !important;\n                }\n\n                &:hover {\n                    background: #f7fafc !important;\n                    transform: none !important;\n                    box-shadow: none !important;\n                }\n\n                td {\n                    font-size: 0.8rem !important;\n                    color: #4a5568 !important;\n                    border: 1px solid #e2e8f0 !important;\n                    padding: 10px 8px !important;\n                    transition: none !important;\n                }\n\n                &:hover td {\n                    border-color: #e2e8f0 !important;\n                }\n            }\n\n            .no-data {\n                text-align: center !important;\n                padding: 60px 40px !important;\n                font-style: italic !important;\n                color: #718096 !important;\n                font-size: 1.1rem !important;\n                background: linear-gradient(135deg, #f7fafc 0%, #e2e8f0 100%) !important;\n                border: 2px dashed #a0aec0 !important;\n                border-radius: 8px !important;\n                margin: 20px !important;\n            }\n        }\n    }\n\n    .pagination-container {\n        display: none !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"store-view-container": `StoreView_store-view-container__9lFDo`,
	"view-header": `StoreView_view-header__OiMVq`,
	"header-buttons": `StoreView_header-buttons__YMWk0`,
	"pagination-controls": `StoreView_pagination-controls__HIzsP`,
	"items-per-page": `StoreView_items-per-page__wDpBv`,
	"refresh-btn": `StoreView_refresh-btn__Zju0k`,
	"print-btn": `StoreView_print-btn__mx6fB`,
	"filter-btn": `StoreView_filter-btn__RFeYq`,
	"excel-btn": `StoreView_excel-btn__W9QQb`,
	"global-search": `StoreView_global-search__wYMnE`,
	"search-input": `StoreView_search-input__fPCTn`,
	"clear-filters-btn": `StoreView_clear-filters-btn__JBQvR`,
	"filters-panel": `StoreView_filters-panel__l-YkG`,
	"slideDown": `StoreView_slideDown__68H8j`,
	"filters-grid": `StoreView_filters-grid__+5QkJ`,
	"filter-group": `StoreView_filter-group__tF6GN`,
	"table-wrapper": `StoreView_table-wrapper__CXEp6`,
	"table-container": `StoreView_table-container__abwNu`,
	"store-table": `StoreView_store-table__OSA5e`,
	"main-header": `StoreView_main-header__+BrC6`,
	"sub-header": `StoreView_sub-header__4n28H`,
	"column-numbers": `StoreView_column-numbers__P-aAO`,
	"data-row": `StoreView_data-row__tTVOw`,
	"no-data": `StoreView_no-data__xdrYT`,
	"loading": `StoreView_loading__-Wi6L`,
	"error": `StoreView_error__7kJdg`,
	"pagination-container": `StoreView_pagination-container__W0Ggp`,
	"pagination-info": `StoreView_pagination-info__dU62W`,
	"filtered-info": `StoreView_filtered-info__EYeAR`,
	"pagination-btn": `StoreView_pagination-btn__Rljox`,
	"active": `StoreView_active__3pnLa`,
	"disabled": `StoreView_disabled__DajO8`
};
export default ___CSS_LOADER_EXPORT___;
